module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/theTrip_1x.6a04872.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/theTrip_1x.png
// module id = KUjR
// module chunks = 41